"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScheduleEntryTypeCategory;
(function (ScheduleEntryTypeCategory) {
    ScheduleEntryTypeCategory["USER"] = "USER";
    ScheduleEntryTypeCategory["RESOURCE"] = "RESOURCE";
})(ScheduleEntryTypeCategory = exports.ScheduleEntryTypeCategory || (exports.ScheduleEntryTypeCategory = {}));
//# sourceMappingURL=ScheduleEntryTypeCategory.js.map